export const globalPromotionsManager = {
  header: {
    title: "Gestione delle promozioni",
    description:
      "Crea e gestisci promozioni sul soggiorno valide per l'intero account. Saranno disponibili per qualsiasi delle tue strutture (appartamenti e hotel).",
  },

  toolbar: {
    info: "Le promozioni create qui possono essere attivate dalla scheda <strong>Promozioni</strong> di ciascuna struttura.",
    newPromotion: "Nuova promozione",
  },

  loading: "Caricamento delle promozioni...",
  close: "Chiudi",
  cancel: "Annulla",
  noLimit: "Nessun limite",

  status: {
    active: "Attiva",
    paused: "In pausa",
  },

  card: {
    stay: "Soggiorno",
    discount: "Sconto",
    validity: "Validità",
    edit: "Modifica",
    delete: "Elimina",
  },

  nights: {
    range: "{min} – {max} notti",
    min: "{min}+ notti",
  },

  discount: {
    fixed: "{value} (fisso)",
  },

  empty: {
    title: "Nessuna promozione creata",
    description:
      "Crea promozioni per incentivare soggiorni più lunghi. Puoi attivarle su ciascuna struttura dalle impostazioni delle prenotazioni dirette.",
    create: "Crea la prima promozione",
  },

  form: {
    editTitle: "Modifica promozione",
    createTitle: "Nuova promozione",
    nameLabel: "Nome della promozione",
    namePlaceholder: "es. sconto 7 notti, Offerta settimanale",
    minNights: "Notti minime",
    maxNights: "Notti massime",
    optional: "(facoltativo)",
    noLimitPlaceholder: "Nessun limite",
    discountType: "Tipo di sconto",
    percentage: "Percentuale",
    fixedAmount: "Importo fisso",
    discountValue: "Valore dello sconto",
    amountSuffix: "importo",
    validFrom: "Valido dal",
    validTo: "Valido fino al",
    activateNow: "Attiva subito la promozione",
    propertiesLabel: "Strutture in cui sarà disponibile",
    selectAll: "Seleziona tutto",
    propertiesHelper:
      "Verranno creati i record di configurazione per le strutture selezionate.",
    infoBox:
      "Potrai in seguito modificare il badge, l'ordine e il comportamento dalla scheda <strong>Promozioni</strong> di ciascuna struttura.",
    saving: "Salvataggio...",
    update: "Aggiorna",
    create: "Crea promozione",
  },

  deleteModal: {
    title: "Elimina promozione",
    warningStrong: "Questa azione non può essere annullata.",
    warningBefore: "Stai per eliminare la promozione",
    warningAfter: ". Non sarà più disponibile su nessuna struttura.",
    confirmLabel: "Digita il nome esatto per confermare:",
    confirmPlaceholder: "Digita il nome della promozione",
    deleting: "Eliminazione...",
    confirmDelete: "Elimina definitivamente",
  },

  toasts: {
    loadError: "Impossibile caricare le promozioni.",
    nameRequired: "Inserisci un nome per la promozione",
    minNightsWarning: "Le notti minime devono essere almeno 1",
    discountValueWarning: "Il valore dello sconto deve essere maggiore di 0",
    selectProperty: "Seleziona almeno una struttura",
    updated: "Promozione aggiornata",
    created: "Promozione creata con successo",
    saveFailed: "Impossibile salvare",
    saveError: "Errore durante il salvataggio della promozione",
    deleted: "Promozione eliminata",
    deleteFailed: "Impossibile eliminare",
    deleteError: "Errore durante l'eliminazione",
  },
};
